var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Base } from "../../framework/base";
import { FileType } from "../enums";
import { EditItem } from "./editItem";
var FileAttachment = /** @class */ (function (_super) {
    __extends(FileAttachment, _super);
    function FileAttachment(obj) {
        var _this = _super.call(this, obj) || this;
        _this.subOwnerId = obj && obj.subOwnerId || "";
        _this.type = obj && obj.type || FileType.Unknown;
        _this.name = obj && obj.name || "";
        _this.size = obj && obj.size || 0;
        _this.category = obj && obj.category || 0;
        _this.modifyDate = obj && obj.modifyDate || 0;
        _this.lastModified = obj && obj.lastModified || 0;
        _this.thumbnail = obj && obj.thumbnail || "";
        _this.file = null;
        if (obj && obj.file) {
            _this.file = new File([obj.file], obj.file.name, { type: obj.file.type });
        }
        return _this;
    }
    FileAttachment.fileToFileAttachment = function (file, category, subOwnerId) {
        if (subOwnerId === void 0) { subOwnerId = ""; }
        return __awaiter(this, void 0, Promise, function () {
            var attachment, base64Picture;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (Base.isNullOrUndefined(file))
                            return [2 /*return*/, null];
                        attachment = new FileAttachment();
                        attachment.id = Base.getGuid();
                        attachment.subOwnerId = subOwnerId;
                        attachment.name = file.name;
                        attachment.size = file.size;
                        attachment.type = Base.getFileType(attachment.name);
                        attachment.category = category;
                        attachment.modifyDate = (new Date()).getTime();
                        attachment.lastModified = file.lastModified;
                        attachment.thumbnail = null;
                        attachment.file = file;
                        if (!(attachment.type === FileType.Image)) return [3 /*break*/, 2];
                        return [4 /*yield*/, Base.blobToBase64(file)];
                    case 1:
                        base64Picture = _a.sent();
                        attachment.thumbnail = base64Picture;
                        return [2 /*return*/, attachment];
                    case 2: return [2 /*return*/, new Promise(function (resolve) { resolve(attachment); })];
                }
            });
        });
    };
    FileAttachment.blobToFileAttachment = function (blob, category, subOwnerId) {
        if (subOwnerId === void 0) { subOwnerId = ""; }
        return __awaiter(this, void 0, Promise, function () {
            var time, name, attachment, base64Picture;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!blob)
                            return [2 /*return*/, null];
                        time = (new Date()).getTime();
                        name = "Photo " + Base.timeToDateTimeStr(time, true) + ".jpg";
                        attachment = new FileAttachment();
                        attachment.id = Base.getGuid();
                        attachment.subOwnerId = subOwnerId;
                        attachment.name = name;
                        attachment.size = blob.size;
                        attachment.type = Base.getFileType(name);
                        attachment.category = category;
                        attachment.modifyDate = time;
                        attachment.lastModified = 0;
                        attachment.thumbnail = null;
                        attachment.file = Base.blobToFile(blob, name);
                        return [4 /*yield*/, Base.blobToBase64(blob)];
                    case 1:
                        base64Picture = _a.sent();
                        attachment.thumbnail = base64Picture;
                        return [2 /*return*/, attachment];
                }
            });
        });
    };
    FileAttachment.photoToFileAttachment = function (dataUrl, category, subOwnerId) {
        if (subOwnerId === void 0) { subOwnerId = ""; }
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                if (Base.isNullOrEmpty(dataUrl))
                    return [2 /*return*/, null];
                return [2 /*return*/, FileAttachment.blobToFileAttachment(Base.dataUriToBlob(dataUrl), category, subOwnerId)];
            });
        });
    };
    FileAttachment.getFirstFileAttachmentFromFileList = function (fileList, category, subOwnerId) {
        if (subOwnerId === void 0) { subOwnerId = ""; }
        if (fileList.length < 1)
            return new Promise(function (resolve) { resolve(null); });
        return FileAttachment.fileToFileAttachment(fileList[0], category, subOwnerId);
    };
    FileAttachment.addFileListToFileAttachments = function (attachments, fileList, category, subOwnerId) {
        if (subOwnerId === void 0) { subOwnerId = ""; }
        return __awaiter(this, void 0, Promise, function () {
            var promises, i, file, result, newAttachments, _i, newAttachments_1, newAttachment;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promises = [];
                        for (i = 0; i < fileList.length; i++) {
                            file = fileList[i];
                            if (Base.isNullOrUndefined(file))
                                continue;
                            promises.push(FileAttachment.fileToFileAttachment(file, category, subOwnerId));
                        }
                        result = attachments.slice(0);
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        newAttachments = _a.sent();
                        for (_i = 0, newAttachments_1 = newAttachments; _i < newAttachments_1.length; _i++) {
                            newAttachment = newAttachments_1[_i];
                            if (Base.isNullOrUndefined(newAttachment))
                                continue;
                            result.push(newAttachment);
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FileAttachment.sortFileAttachments = function (items) {
        if (!items && items.length < 2)
            return items;
        return items.sort(function (a, b) { return (!a || !b) ? 0 : (Base.strCompare(a.name, b.name)); });
    };
    return FileAttachment;
}(EditItem));
export { FileAttachment };
